import { Component, OnInit, Input } from '@angular/core';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { Router } from '@angular/router';
import { BannerItemListModel, sideBannerItemType } from '@components/slider/sideBanner/side-banner-slider.model';

@Component({
  selector: 'side-slider-slider',
  templateUrl: './side-banner-slider.component.html',
})
export class SideBannerSliderComponent implements OnInit {
  @Input()
  _sblocationid: number;

  public _newSideBannerList: BannerItemListModel = new BannerItemListModel([]);

  constructor(private _ApiService: ApiService, public _Router: Router, public _LZ: LocalizationService) {}
  ngOnInit() {
    this._ApiService.getSideBanner().then((x: sideBannerItemType[]) => {
      this._newSideBannerList = new BannerItemListModel(x, this._sblocationid);
    });
  }
}
